export const ACCOUNT_TYPE = {
  ADMIN: "admin",
  MANAGER: "Manager",
  ORGANIZATION: "Organization",
  USER: "USER",
}